var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DialogModal',{attrs:{"isOpen":!!_vm.component,"title":_vm.title},on:{"onClose":_vm.handleModalClose}},[_c(_vm.component,_vm._b({tag:"component",on:{"onClose":_vm.handleClose}},'component',_vm.props,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }